module.exports = __webpack_public_path__ + "static/computer-code-fb6592c269e2cd20ad6a7fbb5134c788.png";